import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-start" }
const _hoisted_2 = ["checked", "disabled", "id"]
const _hoisted_3 = ["for"]

import InputField from './InputField.vue';
import { ref } from 'vue';
import { v4 } from 'uuid';


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    type: Boolean,
  },
  title: {
    type: String,
    default: null,
  },
  hint: {
    type: String,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  validationError: {
    type: String,
    default: null,
  },
  status: {
    type: String,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {





function onUpdate(event: Event) {
  const element = event.target as HTMLInputElement;
  emit('update:modelValue', element.checked);
}

const uuid = ref(v4());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InputField, { hint: __props.hint }, {
    status: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.status), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("input", {
          type: "checkbox",
          checked: __props.modelValue,
          disabled: __props.disabled,
          id: uuid.value,
          onInput: onUpdate,
          onChange: onUpdate,
          class: "py-1 my-2 mr-2 border-b border-input-decoration"
        }, null, 40, _hoisted_2),
        _createElementVNode("label", { for: uuid.value }, _toDisplayString(__props.title), 9, _hoisted_3)
      ])
    ]),
    _: 1
  }, 8, ["hint"]))
}
}

})